import * as SC from '@/components/modal/settings/settings.style';
import strings from '@/i18n/index';
import useNotificationStore from '@/stores/notificationStore';

const Alarm = () => {
  const { isAllowedNotification, changeIsAllowedNotification, soundOn, changeSoundOn } = useNotificationStore();

  return (
    <SC.Wrapper>
      <SC.CategoryWrapper>
        <SC.CategoryTitle>{strings.NOTICE}</SC.CategoryTitle>
        <SC.BrowserAlarmGuideText>{strings.MSG__.ALLOW_BROWSER_ALARM}</SC.BrowserAlarmGuideText>
        <SC.CategoryLabel htmlFor='use'>
          <SC.HiddenInput
            type='radio'
            id='use'
            value='use'
            name='alarm'
            checked={isAllowedNotification}
            onChange={() => {
              changeIsAllowedNotification(true);
            }}
          />
          <SC.RadioWrapper>
            <SC.Radio />
          </SC.RadioWrapper>
          <SC.ThemeCardTitle>{strings.SETTINGS__ALL_MESSAGES}</SC.ThemeCardTitle>
        </SC.CategoryLabel>

        <SC.CategoryLabel htmlFor='notUse'>
          <SC.HiddenInput
            type='radio'
            id='notUse'
            value='notUse'
            name='alarm'
            checked={!isAllowedNotification}
            onChange={() => {
              changeIsAllowedNotification(false);
            }}
          />
          <SC.RadioWrapper>
            <SC.Radio />
          </SC.RadioWrapper>
          <SC.ThemeCardTitle>{strings.SETTINGS__NONE}</SC.ThemeCardTitle>
        </SC.CategoryLabel>
      </SC.CategoryWrapper>
      <SC.CategoryWrapper className='sec'>
        <SC.CategoryTitle>{strings.SETTINGS__ALARM_SOUND}</SC.CategoryTitle>
        <SC.CategoryLabel disabled={!isAllowedNotification} htmlFor='soundUse'>
          <SC.HiddenInput
            type='radio'
            id='soundUse'
            value='soundUse'
            name='sound'
            checked={soundOn}
            aria-checked={soundOn}
            disabled={!isAllowedNotification}
            onChange={() => {
              changeSoundOn(true);
            }}
          />
          <SC.RadioWrapper>
            <SC.Radio />
          </SC.RadioWrapper>
          <SC.ThemeCardTitle>{strings.SETTINGS__SOUND_ALARM}</SC.ThemeCardTitle>
        </SC.CategoryLabel>

        <SC.CategoryLabel disabled={!isAllowedNotification} htmlFor='soundNotUse'>
          <SC.HiddenInput
            type='radio'
            id='soundNotUse'
            value='soundNotUse'
            name='sound'
            checked={!soundOn}
            aria-checked={!soundOn}
            disabled={!isAllowedNotification}
            onChange={() => {
              changeSoundOn(false);
            }}
          />
          <SC.RadioWrapper>
            <SC.Radio />
          </SC.RadioWrapper>
          <SC.ThemeCardTitle>{strings.SETTINGS__NONE}</SC.ThemeCardTitle>
        </SC.CategoryLabel>
      </SC.CategoryWrapper>
    </SC.Wrapper>
  );
};

export default Alarm;
